import { render, staticRenderFns } from "./monitoring-duration.vue?vue&type=template&id=6bdce447&"
import script from "./monitoring-duration.vue?vue&type=script&lang=js&"
export * from "./monitoring-duration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports